import { ActionTree } from 'vuex'
import { IAppState } from './types'
import {
  getAppInfo,
  updateAppInfo,
  getAppAuthConfigs,
  saveAppAuthConfigs,
  updateAppAuthConfigs,
  getCompanyList,
  getSyncInfo,
  getApplyFeatureList,
  getCompanyId
} from '@/apps/open/services/app'

const actions: ActionTree<IAppState, any> = {
  GET_APP_INFO: async ({ commit }, id: string) => {
    try {
      const res = await getAppInfo(id)
      const appInfo = res.data.object
      commit('SET_APP_INFO', appInfo)
      return Promise.resolve(appInfo)
    } catch (error) {
      commit('SET_APP_INFO')
      return Promise.reject(error)
    }
  },

  GET_COMPANY_LIST: async ({ commit }, developer_id: number | string) => {
    try {
      const res = await getCompanyList(developer_id)
      const companyList = res.data.object_array
      commit('SET_COMPANY_LIST', { companyList })
      return Promise.resolve(companyList)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  GET_COMPANY_ID: async ({ commit }, appId: string) => {
    try {
      const res = await getCompanyId(appId)
      const companyId = res.data.open_comp_id
      commit('SET_COMPANY_ID', { companyId })
      return Promise.resolve(companyId)
    } catch (error) {
      commit('SET_COMPANY_ID', { companyId: undefined })
      return Promise.reject(error)
    }
  },

  GET_APPLY_FEATURE_LIST: async ({ commit }, appId: string) => {
    try {
      const res = await getApplyFeatureList(appId)
      const applyFeatureList = res.data.object_array
      commit('SET_APPLY_FEATURE_LIST', { applyFeatureList })
      return Promise.resolve(applyFeatureList)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  GET_SYNC_INFO: async ({ commit }, app_id: string) => {
    try {
      const res = await getSyncInfo(app_id)
      const syncInfo = res.data
      commit('SET_SYNC_INFO', syncInfo)
      return Promise.resolve(syncInfo)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  UPDATE_APP_INFO: async ({ commit }, info: any) => {
    try {
      await updateAppInfo(info)
      commit('UPDATE_APP_INFO', info)
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  },

  GET_APP_AUTH_CONFIGS: async ({ commit }, id: string) => {
    try {
      const res = await getAppAuthConfigs(id)
      commit('SET_APP_AUTH_CONFIGS', {
        appAuthConfigs: res.data
      })
      return Promise.resolve({
        appAuthConfigs: res.data
      })
    } catch (error) {
      commit('SET_APP_AUTH_CONFIGS')
      return Promise.reject(error)
    }
  },

  SAVE_APP_AUTH_CONFIGS: async ({ commit }, data: any) => {
    try {
      await saveAppAuthConfigs(data)
      commit('SET_APP_AUTH_CONFIGS', data)
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  },

  UPDATE_APP_AUTH_CONFIGS: async ({ commit }, data: any) => {
    try {
      await updateAppAuthConfigs(data)
      commit('SET_APP_AUTH_CONFIGS', data)
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default actions
